import React from "react";
import { Link } from "react-router-dom";

export const NoStaffNote = ({ list, testid = "no-staff-note" }) => {
  if (list && list.length) return null;
  return (
    <p data-testid={testid} className="text-[11px] text-amber-600 mt-1">
      No ISOQuest staff added yet. <Link to="/accounts" className="underline">Add people in Accounts</Link> first.
    </p>
  );
};
